import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { priceListRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const priceListRouteMetadata: IRouteMetadataObj<typeof priceListRoutesObj> = {
  list: {
    title: "warehouseManagement.index.title",
    description: "empty",
    lazy: () => import("@pages/warehouseManagement/priceList/table/page"),
    mode: "index",
    type: "main",
    icon: "Building2Line",
    breadcrumbs: [],
    permission,
  },
  insertNewPrice: {
    title: "warehouseManagement.priceList.insertNewPrice.title",
    description: "empty",
    lazy: () => import("@pages/warehouseManagement/priceList/form/page"),
    mode: "create",
    type: "inner",
    icon: "PriceTag3Line",
    breadcrumbs: [],
    permission,
  },
  itemPriceHistory: {
    title: "warehouseManagement.priceList.itemPriceHistory.title",
    description: "empty",
    lazy: () =>
      import("@pages/warehouseManagement/priceList/itemPriceHistory/table/page"),
    mode: "index",
    type: "inner",
    icon: "CalendarCheckLine",
    breadcrumbs: [],
    permission,
  },
};

export const priceListRoutes = createRoute<typeof priceListRoutesObj>(
  priceListRoutesObj,
  priceListRouteMetadata,
);
